import React from 'react'
import Obfuscate from 'react-obfuscate'
import 'font-awesome/css/font-awesome.min.css'
import Markdown from 'markdown-it'

import './cv.css'
import CVHeader from './CVHeader'
import CVPosition from './CVPosition'
import CVEducation from './CVEducation'
import CVSkill from './CVSkill'

import resume from './resume.json'
const md = Markdown()

class Resume extends React.Component {
  render() {
    return (
      <article className="resume">
        <CVHeader {...resume.basics} />
        <main className="main">
          <div id="about">
            <h2>
              <i className="fa fa-user left" /> ABOUT
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: md.render(resume.basics.summary),
              }}
            />
          </div>
          <div id="work">
            {resume.work && [
              <h2 key="header">
                <i className="fa fa-suitcase left" /> WORK EXPERIENCE
              </h2>,
              resume.work.map((job, index) => (
                <CVPosition
                  key={`${job.position}.${job.company}.${job.startDate}`}
                  organization={job.company}
                  initiallyOpen={index === 0}
                  {...job}
                />
              )),
            ]}
          </div>
          {resume.education && (
            <div id="education">
              <h2>
                <i className="fa fa-graduation-cap left" /> EDUCATION
              </h2>
              {resume.education.map(education => (
                <CVEducation
                  key={`${education.institution}.${education.startDate}`}
                  {...education}
                />
              ))}
            </div>
          )}

          <div id="volunteer">
            {resume.volunteer && [
              <h2 key="header">
                <i className="fa fa-child left" /> VOLUNTEER WORK
              </h2>,
              resume.volunteer.map((volunteer, index) => (
                <CVPosition
                  key={`${volunteer.position}.${volunteer.organization}.${
                    volunteer.startDate
                  }`}
                  initiallyOpen={index === 0}
                  {...volunteer}
                />
              )),
            ]}
          </div>
          {resume.skills && (
            <div id="skills">
              <h2>
                <i className="fa fa-tasks left" /> SKILLS
              </h2>
              {resume.skills.map(skill => (
                <CVSkill key={skill.name} {...skill} />
              ))}
            </div>
          )}
          <br />

          {/* <div id="awards">
            <h2>
              <i className="fa fa-trophy left" /> AWARDS
            </h2>
            <h3>Digital Compression Pioneer Award - Techcrunch</h3>
            <h4>01 November 2014</h4>
            <p>There is no spoon.</p>
          </div>
          <div id="publications">
            <h2>
              <i className="fa fa-book left" /> PUBLICATIONS
            </h2>
            <h3>Video compression for 3d media</h3>
            <h4>01 October 2014</h4>
            <p>
              Innovative middle-out compression algorithm that changes the way
              we store data.<br />
              <a
                href="http://en.wikipedia.org/wiki/Silicon_Valley_(TV_series)"
                target="_blank"
              >
                http://en.wikipedia.org/wiki/Silicon_Valley_(TV_series)
              </a>
            </p>
          </div>
          <div id="interests">
            <h2>
              <i className="fa fa-star left" /> INTERESTS
            </h2>
            <h3 className="skills">Wildlife</h3>
            <span className="keywords">Ferrets</span>
            <span className="keywords">Unicorns</span>
          </div>
          <div id="languages">
            <h2>
              <i className="fa fa-language left" /> LANGUAGES
            </h2>
            <h3>English</h3>
            <h4>Fluency: Native speaker</h4>
          </div>
          <div id="references">
            <h2>
              <i className="fa fa-thumbs-up left" /> REFERENCES
            </h2>
            <blockquote>
              It is my pleasure to recommend Richard, his performance working as
              a consultant for Main St. Company proved that he will be a
              valuable addition to any company.
              <div className="name">
                <br />- Erlich Bachman
              </div>
            </blockquote>
            <br />
          </div> */}
        </main>
      </article>
    )
  }
}

export default Resume



// WEBPACK FOOTER //
// ./src/components/cv/CV.js